/**
 * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
 * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
 *
 * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
 */

//the type of items blocks for dynamic rendering
export default {
    html: 'html', // static HTML as a string
    text: 'text', // text as a string
    container: 'container', // a node as a component, using a static  element
    element: 'element' // a QTI element (interaction or static element)
};
